import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import messages from '@/pages/SpaceAnalyticsPage/messages'

import DifferenceTool from './DifferenceTool'

const MetricHorizontalSection = ({ icon, label, value, differenceValue, renderDifferenceValue = true }: any) => {
  return (
    <div className="metric-horizontal-section">
      <div className="icon">
        <div className="icon-holder">{icon}</div>
      </div>
      <div className="metric">
        <div className="name">{label}</div>
        <div className="value">{value.toLocaleString()}</div>
      </div>
      {renderDifferenceValue && (
        <div className="difference">
          {(differenceValue || differenceValue === 0) && (
            <DifferenceTool
              currentTotal={value}
              previousTotal={differenceValue}
              className="percentage"
              color={determineColor(value, differenceValue)}
            />
          )}
        </div>
      )}
    </div>
  )
}

MetricHorizontalSection.displayName = 'MetricHorizontalSection'

MetricHorizontalSection.defaultProps = {
  label: <FormattedMessage {...messages.missingContent} />,
  value: 1000,
  differenceValue: null
}

MetricHorizontalSection.propTypes = {
  icon: PropTypes.element.isRequired,
  label: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
  differenceValue: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  renderDifferenceValue: PropTypes.bool
}

const determineColor = (current: any, previous: any) => {
  if (current < previous) return 'red'
  else if (current > previous) return 'green'
  else return '#494949'
}

export default MetricHorizontalSection
